import React from 'react';

class CountDown extends React.Component {

    constructor(props) {
        super(props);

        this.timer = false;
        this.initialState = {
            hh: '00',
            mm: '00',
            ss: '00',
        }
        this.state = this.initialState;
    }

    componentDidMount() {
        this.startTimer();
    }

    componentWillReceiveProps(nextProps) {
        clearInterval(this.timer);
        if (nextProps.expiryTime != null) this.startTimer();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    startTimer() {
        if (this.props.expiryTime != null) {
            this.timer = setInterval(() => {
                this.setState(this.calcTime(this.props.expiryTime));
            }, 1000);
        }
    }

    calcTime(expiryTime) {
        let hh, mm, ss, now = new Date();

        let diffInSeconds = (new Date(expiryTime) - now)/1000;

        hh = Math.floor(diffInSeconds / 3600);
        mm = Math.floor(diffInSeconds % 3600 / 60);
        ss = Math.floor(diffInSeconds % 3600 % 60);

        if (diffInSeconds <= 1) {
            clearInterval(this.timer);
            setTimeout(this.props.hasExpired, 1000);
            return this.initialState;
        };

        return {
            hh: this.addZero(hh),
            mm: this.addZero(mm),
            ss: this.addZero(ss)
        };

    }

    addZero(digit) {
        let str = digit.toString();
        return (str.length == 1) ? '0'+str : str;
    }

	render() {
        let { hh, mm, ss } = this.state;
        if (this.props.expiryTime == null) return '\u00A0';
        return hh+':'+mm+':'+ss;
    }
}

export default CountDown;



// WEBPACK FOOTER //
// ./source/components/countDown.js